import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import MainHeadingOutput from './../../components/MainHeadingOutput/MainHeadingOutput';
import ClearFormButton from './../../components/ClearFormButton/ClearFormButton';
import fetchMainHeadingAction from './../../store/actions/fetch/fetchMainHeadingAction';
import Loader from './../../components/Loader/Loader'
import * as actionTypes from "../../store/actions/mainHeadingAction";

/**
 * Main Heading container
 */
class MainHeading extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, defaultValues, ready} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-main-heading-output__wrapper'>
        {error && <span className='nppe2-fc-main-heading-output__error'>{error}</span>}
        {!error &&
        <MainHeadingOutput
          data={data}
        />
        }
        {!error && <ClearFormButton/>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.mainHeadingReducer.error,
    data: state.mainHeadingReducer.data,
    pending: state.mainHeadingReducer.pending,
    ready: state.mainHeadingReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchMainHeadingAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainHeading);
